import { getLanguageCodeByCondUuid } from 'app/utils/language';
import { SetStateAction, useState } from 'react';
import { IWebChatModule } from 'app/services/ostroAdapter';

import LanguageIcon from '../../../components/icons/LanguageIcon';

export default function TailorLanguageSelector({
  languages,
  selectedLanguageCondition,
  onLanguageChange,
}: {
  languages: IWebChatModule[];
  selectedLanguageCondition: string;
  onLanguageChange: (language: string, langCode: string | null, prevLangCode: string | null) => void;
}) {
  const [language, setLanguage] = useState(selectedLanguageCondition);

  const handleLanguageChange = (event: { target: { value: SetStateAction<string> } }) => {
    const condition_uuid = event.target.value as string;
    const new_language_code = getLanguageCodeByCondUuid(languages, condition_uuid);
    const prev_language_code = getLanguageCodeByCondUuid(languages, selectedLanguageCondition);

    onLanguageChange(condition_uuid, new_language_code, prev_language_code);
    setLanguage(condition_uuid);
  };

  return (
    <div
      id="ostro-tailor-language-selector-container"
      className="bg-black text-white py-3 px-10 relative flex items-center justify-center"
    >
      <LanguageIcon />{' '}
      <select
        id="language-select"
        title="Select language"
        value={language}
        onChange={handleLanguageChange}
        className="ml-2 bg-black text-([#F3F3F3]) opacity-90 text-xs text-center block pr-2 pl-1 py-2 border-none rounded-md shadow-sm focus:outline-none focus:ring-none"
      >
        {languages.map((lang) => (
          <option
            key={lang.module}
            value={lang.condition_uuid}
          >
            {lang.localization_title}
          </option>
        ))}
      </select>
    </div>
  );
}
